import {useContext, useState} from 'react'
import {Link} from 'react-router-dom'
import EntityPerformanceChartModal from '../../../../components/EntityPerformanceChartModal/EntityPerformanceChartModal'
import { CustomerReportContext } from '../../context'
import { MIN_DATE_RANGE } from '../../utils'

const CustomerGroupReportRow = ({row}: any) => {
  const [showChartModal, setShowChartModal] = useState(false)
  const {
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
    isEntityPerformanceChartDataLoading,
    entityPerformanceChartData,
  } = useContext(CustomerReportContext)
    
  return (
    <>
      <tr>
        <td>{row.customerGroupName}</td>
        <td>
          <Link
            to={{
              pathname: '/analytics/profitability/profitability-report',
              search: `?view=order-report&report_type=shipping&customer_group=${row.customerGroupId}`,
            }}
            target='_blank'
            className='text-dark text-decoration-underline'
          >
            {row.orderCount}
          </Link>
        </td>
        <td>{row.totalShipping}</td>
        {/* <td>{row.contributionSalePercentage}</td> */}
        <td>{row.contributedShippingPercentage}</td>
        <td>
          <div className='d-flex justify-content-end'>
            <span
              onClick={() => setShowChartModal(true)}
              className='w-30px h-30px d-flex justify-content-center align-items-center text-primary cursor-pointer'
            >
              <i className='fas fa-chart-line text-primary'></i>
            </span>
          </div>
        </td>
      </tr>
        {showChartModal && (
          <EntityPerformanceChartModal
            onClose={() => setShowChartModal(false)}
            entityId={row.customerGroupId}
            entityName={`Shipping Report - ${row.customerGroupName}`}
            onEntityPerformanceChartIdChange={onEntityPerformanceChartIdChange}
            onEntityPerformanceChartViewChange={onEntityPerformanceChartViewChange}
            onEntityPerformanceChartDateRangeChange={onEntityPerformanceChartDateRangeChange}
            entityPerformanceChartFilters={entityPerformanceChartFilters}
            isEntityPerformanceChartDataLoading={isEntityPerformanceChartDataLoading}
            entityPerformanceChartData={entityPerformanceChartData}
            startDate={MIN_DATE_RANGE}
          />
        )}
    </>
  )
}

export default CustomerGroupReportRow
